import { render, staticRenderFns } from "./ClientCard.vue?vue&type=template&id=78cb76c0"
import script from "./ClientCard.vue?vue&type=script&lang=js"
export * from "./ClientCard.vue?vue&type=script&lang=js"
import style0 from "./ClientCard.vue?vue&type=style&index=0&id=78cb76c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports